import { showSimpleDialog } from './ui_popup/showSimpleDialog.ts';
import { notificationController, uiManagerEvents } from './EntryShared.ts';
import { isSubscriptionOverlayVariant } from './store/subscription_overlay/subscriptionOverlayABTest.ts';
import { LobbyImage } from '@colonist/types';
import { UITopNotificationType } from './notifications/UINotificationController.ts';
import { DISCORD_CHANNEL } from '@colonist/consts';
import { navigateToPage } from './ui_utils/ClientUtils.ts';
export function registerSharedRoomClientHandlers(roomClient) {
    roomClient.onInvalidPlayerCountEncountered((playerCount, missingExtension)=>{
        const popupTitle = {
            key: 'strings:popups.informationView.title'
        };
        const popupBody = {
            key: missingExtension ? 'strings:roomPage.notifications.failedToSelectPlayerCount' : 'strings:roomPage.notifications.invalidGameModeSelected',
            options: {
                playerCount: playerCount
            }
        };
        const storeConfirmProps = missingExtension ? {
            confirmLabel: {
                key: 'strings:colonistCommon.buttons.store'
            },
            onConfirm: ()=>{
                if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
                else navigateToPage('/store', true, true);
            }
        } : {};
        showSimpleDialog({
            title: popupTitle,
            body: popupBody,
            ...storeConfirmProps
        });
    });
    roomClient.onFailedToReducePlayerCount(()=>{
        notificationController.showNotification(LobbyImage.Lightning, {
            key: 'strings:roomPage.notifications.kickPlayersBeforeMakingRoomSmaller'
        });
    });
    roomClient.onFailedToStartGameBecauseServerIsUpdating(()=>{
        notificationController.show({
            key: 'strings:colonistCommon.serverStatus.serverUpdating',
            options: {
                discordLink: DISCORD_CHANNEL
            }
        }, UITopNotificationType.Information);
    });
    roomClient.onFailedToStartGamePlayersNotReady((players)=>{
        notificationController.showNotification(LobbyImage.Lightning, {
            key: 'strings:roomPage.notifications.usersNotReadyToPlay',
            options: {
                usernames: players,
                count: players.length
            }
        });
    });
    roomClient.onFailedToSelectUsedColor(()=>{
        notificationController.showNotification(LobbyImage.Lightning, {
            key: 'strings:roomPage.notifications.colorNotAvailable'
        });
    });
    roomClient.onFailedToExecuteCommandGameStarting(()=>{
        notificationController.showNotification(LobbyImage.Lightning, {
            key: 'strings:roomPage.notifications.gameStarting'
        });
    });
    roomClient.onFailedToSetGameSpeed(()=>{
        notificationController.showNotification(LobbyImage.Lightning, {
            key: 'strings:roomPage.notifications.failedToSetGameSpeed'
        });
    });
}
